var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',[_c('vx-card',[_c('h1',{staticClass:"mb-6"},[_vm._v("FAQ")]),_c('vs-collapse',_vm._l((_vm.contents),function(item,i){return _c('vs-collapse-item',{key:i},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_vm._v(_vm._s(item.title))]),_c('div',{domProps:{"innerHTML":_vm._s(item.content)}})])}),1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }